import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  Amenity,
  AmountData,
  AmountResponse,
  ApiBaseError,
  ApiParams,
  DataList,
  Dates,
  Gym,
  Sessions,
  Type,
} from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class GymService {
  constructor(private apiService: ApiService) {
    this.getUserPath();
  }

  getUserPath() {
    this.apiService.getUserPath();
  }

  list(apiParams: ApiParams): Observable<DataList<Gym>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Gym>>(`${this.apiService.userPath}gyms`, apiParams).pipe();
  }

  recent(apiParams: ApiParams): Observable<DataList<Gym>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Gym>>(`${this.apiService.userPath}gyms/recent`, apiParams).pipe();
  }

  again(apiParams: ApiParams): Observable<DataList<Gym>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Gym>>(`${this.apiService.userPath}bookings/recent`, apiParams).pipe();
  }

  recentDelete(id: number): Observable<ApiBaseError> {
    this.apiService.getUserPath();
    return this.apiService.delete<ApiBaseError>(`${this.apiService.userPath}gyms/recent/${id}`).pipe();
  }

  all(): Observable<DataList<Gym>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Gym>>(`${this.apiService.userPath}gyms`).pipe();
  }

  get(id: number): Observable<Gym> {
    this.apiService.getUserPath();
    return this.apiService.get<Gym>(`${this.apiService.userPath}gyms/${id}`).pipe();
  }

  sessions(id: number, date: string): Observable<DataList<Sessions>> {
    this.apiService.getUserPath();
    return this.apiService
      .get<DataList<Sessions>>(`${this.apiService.userPath}gyms/${id}/sessions?date=${date}`)
      .pipe();
  }

  dates(id: number): Observable<DataList<Dates>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Dates>>(`${this.apiService.userPath}gyms/${id}/dates`).pipe();
  }

  amount(id: number, session_id: number, model: string, data: AmountData): Observable<AmountResponse> {
    this.apiService.getUserPath();
    return this.apiService
      .post<AmountResponse>(
        `${this.apiService.userPath}gyms/${id}/${model === 'session' ? 'sessions' : 'classes'}/${session_id}/amount`,
        data,
      )
      .pipe();
  }

  amenities(): Observable<DataList<Amenity>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Amenity>>(`${this.apiService.userPath}amenities`).pipe();
  }

  types(): Observable<DataList<Type>> {
    this.apiService.getUserPath();
    return this.apiService.get<DataList<Type>>(`${this.apiService.userPath}gym_categories`).pipe();
  }
}
